import React from 'react';

import PropTypes from 'prop-types';

import { useHistory } from 'react-router-dom';
import { Button, Col, Modal, Row } from 'antd';

const ModalLeaveOpimisation = ({t, modalCancelVisible, closeModal, optAlert, setOptAlert, setOptStart }) => {
  const history = useHistory();

  const cancelWithoutChange = () => {
    const path = optAlert.path;
    const state = optAlert.state;
    setOptAlert({ flag: false, path: '' });
    setOptStart(false);
    closeModal();
    history.push(path, state);
  };

  return (
    <Modal
        width={650}
        className="modal-content-paper"
        open={modalCancelVisible}
        onCancel={closeModal}
        footer={null}
        zIndex={1620}
      >
        <Row justify="center">
          <Col className="modal-title">{t('WARNING_OPT')}</Col>
        </Row>
        <Row justify="center" className="modal-text-wrapper">
          <Col span={18}>
            <p className="modal-text">{t('WARNING_OPT_TEXT')}</p>
          </Col>
        </Row>

        <Row className="modal-button-wrapper">
          <Button
            className="modal-action-btn cancel-btn"
            onClick={cancelWithoutChange}
          >
            {t('LEAVE_OPTIMIZATION_FLOW')}
          </Button>
          <Button className="modal-action-btn save-btn" onClick={closeModal}>
            {t('CONTINUE_OPTIMIZATION')}
          </Button>
        </Row>
      </Modal>
  );
};

export default ModalLeaveOpimisation;

ModalLeaveOpimisation.propTypes = {
  t: PropTypes.func.isRequired,
  modalCancelVisible: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  optAlert: PropTypes.object.isRequired,
  setOptAlert: PropTypes.func,
  setOptStart: PropTypes.func,
};